import { useLanguage } from "@/lib/LanguageContext";
import { useReveal } from "@/lib/useReveal";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      data-testid="testimonials-section"
      className="px-6 sm:px-12 lg:px-24 py-24 sm:py-32 bg-[#0D0E13] border-y border-white/5"
    >
      <div ref={ref} className="reveal max-w-3xl mb-16">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D97736] mb-4">
          {t.testimonials.overline}
        </p>
        <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
          {t.testimonials.title}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {t.testimonials.items.map((item, i) => (
          <figure
            key={i}
            data-testid={`testimonial-${i}`}
            className="group p-8 lg:p-10 bg-[#14161A] border border-white/5 hover:border-[#D97736]/40 transition-all duration-300 flex flex-col"
          >
            <Quote className="w-8 h-8 text-[#D97736] mb-6" strokeWidth={1.5} />
            <blockquote className="text-white text-lg leading-relaxed font-light mb-8 flex-1">
              "{item.quote}"
            </blockquote>
            <figcaption className="pt-6 border-t border-white/10">
              <div className="font-display font-bold text-white tracking-tight">
                {item.name}
              </div>
              <div className="text-xs uppercase tracking-widest text-[#A0AAB2] mt-1">
                {item.loc}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
